import { Alert, Modal } from "@xola/ui-kit";
import React from "react";
import { SecondaryButton } from "../../Common/SecondaryButton";

interface CancellationProtectionRefundBlockedProps {
    onClose: () => void;
}

export const CancellationProtectionRefundBlocked = ({ onClose }: CancellationProtectionRefundBlockedProps) => {
    return (
        <div data-testid="cancellation-protection-refund-blocked">
            <Modal.Header>Refund Unavailable</Modal.Header>
            <Modal.Body>
                <Alert color="warning">
                    This booking was settled by a Cancellation Protection claim. The traveler has already been refunded,
                    so no further refund can be issued here.
                </Alert>
            </Modal.Body>
            <Modal.Footer className="flex justify-end">
                <SecondaryButton onClick={onClose}>Close</SecondaryButton>
            </Modal.Footer>
        </div>
    );
};
